import { Link } from "react-router-dom";
import "./Article.scss";

const getValue = (values, attribute) =>
  values.find((value) => value.code === attribute)
    ? values.find((value) => value.code === attribute).value
    : "";

const Article = ({ article, i }) => (
  <div key={i} className="article-component">
    <div style={{ maxHeight: 18, marginBottom: 16 }}>
      <div>{getValue(article.values, "TESTATA")}</div>
    </div>
    <div style={{ marginBottom: 24 }}>
      <h4 className="module" style={{ height: "5.6rem" }}>
        <div className="fade">
          {article.values.find((value) => value.code === "TITOLO").value}
        </div>
      </h4>
    </div>
    <div style={{ display: "flex", justifyContent: "center" }}>
      <Link
        to={"/notizia/" + article.id}
        className="btn ml-auto"
        style={{ maxWidth: "8rem" }}
      >
        Leggi di più
      </Link>
    </div>
  </div>
);

export default Article;
